import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/LogoW.webp';

const API = process.env.REACT_APP_API_URL || 'https://api.pixlybooth.com';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email }, { withCredentials: true });
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0B0F1F', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: 'Arial, Helvetica, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Link to="/"><img src={logo} alt="PixlyBooth" style={{ maxWidth: 160 }} /></Link>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #101428 0%, #0D0F20 100%)', borderRadius: 18, padding: 32, border: '1px solid rgba(227,67,100,0.3)', boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
          {sent ? (
            <>
              <div style={{ textAlign: 'center', fontSize: 40, marginBottom: 16 }}>📧</div>
              <h1 style={{ margin: '0 0 4px', fontSize: 22, color: '#27C85A', fontWeight: 700, textAlign: 'center' }}>Check your inbox</h1>
              <p style={{ color: '#a0a0b8', fontSize: 14, lineHeight: 1.7, textAlign: 'center', margin: '8px 0 24px' }}>
                If an account exists for <strong style={{ color: '#fff' }}>{email}</strong>,
                a password reset link has been sent.
              </p>
              <Link to="/login" style={{ display: 'block', textAlign: 'center', color: '#E34364', textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>
                ← Back to Login
              </Link>
            </>
          ) : (
            <>
              <h1 style={{ margin: '0 0 4px', fontSize: 22, color: '#E34364', fontWeight: 700 }}>Reset your password</h1>
              <p style={{ margin: '0 0 28px', fontSize: 13, color: '#a0a0b8' }}>We'll send a reset link to your email</p>

              {error && (
                <div style={{ background: 'rgba(227,67,100,0.1)', border: '1px solid rgba(227,67,100,0.3)', borderRadius: 10, padding: '12px 16px', marginBottom: 20, color: '#E34364', fontSize: 13 }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 24 }}>
                  <label style={{ display: 'block', fontSize: 12, color: '#a0a0b8', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Email Address</label>
                  <input
                    type="email" required value={email} onChange={e => setEmail(e.target.value)}
                    style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 14px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
                    placeholder="you@example.com"
                  />
                </div>
                <button
                  type="submit" disabled={loading}
                  style={{ width: '100%', background: loading ? '#555' : '#E34364', color: '#fff', border: 'none', borderRadius: 50, padding: '14px 0', fontSize: 14, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}
                >
                  {loading ? 'Sending…' : 'Send Reset Link →'}
                </button>
              </form>

              <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: '#a0a0b8' }}>
                <Link to="/login" style={{ color: '#E34364', textDecoration: 'none' }}>← Back to Login</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
